import React, { useState, useEffect } from 'react';
import { CreditCard, Loader2, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import PaymentModal from './PaymentModal';
import toast from 'react-hot-toast';

// Smart Payment Modal - Always uses live payments
const SmartPaymentModal = ({ 
  isOpen, 
  onClose, 
  paymentData, 
  onSuccess, 
  onFailure,
  title = "Complete Payment"
}) => {
  // Handle payment success
  const handlePaymentSuccess = (response, transactionData) => {
    toast.success('Payment completed successfully!');
    onSuccess && onSuccess(response, transactionData);
  };

  // Handle payment failure
  const handlePaymentFailure = (error) => {
    toast.error('Payment failed. Please try again.');
    onFailure && onFailure(error);
  };

  // Always use live PaymentModal
  return (
    <PaymentModal
      isOpen={isOpen}
      onClose={onClose}
      paymentData={paymentData}
      onSuccess={handlePaymentSuccess}
      onFailure={handlePaymentFailure}
      title={title}
    />
  );
};

export default SmartPaymentModal;
